module.exports = __webpack_public_path__ + "static/media/impersonate-group.8f005f27.svg";